export default __webpack_public_path__ + "static/media/E10.f322c6df.mp3";